import React from 'react';

const ArrowIcon = ({ direction = 'right', size = 20, color = '#F5F7FA' }) => {
  const paths = {
    right: 'M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z',
    upRight: 'M19 5v14h-2V7.41L5.41 19 4 17.59 15.59 6H7V4h12z',
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={paths[direction] || paths.right} fill={color} />
    </svg>
  );
};

export default ArrowIcon;

